import {Component} from 'react';
import _ from 'lodash';
import {Input} from 'antd';

import React from 'react';

export default class TextAreaBouncy extends Component {
  constructor(props) {
    super(props);
    this.state = {value: props.value};
  }

  update(event) {
    this.update = _.debounce(
      (event) => {
        if (this.props.onChange) {
          this.props.onChange(event);
        }
      },
      100,
    );
    this.update(event);
  }

  get onChange() {
    return (event) => {
      event.persist();
      this.setState({value: _.get(event, 'target.value', '')}, () => {
        this.update(event);
      });
    };
  }

  autoSize() {
    return {
      minRows: _.get(this, 'props.minRows', 3),
      maxRows: _.get(this, 'props.maxRows', 6)
    }
  }

  render() {
    return (<Input.TextArea
      value={this.state.value}
      autosize={this.autoSize()}
      onChange={this.onChange}
    />);
  }
}
